import React from 'react';
import moment from 'moment';

const NextBillingDateSelect = ({ input, NextBillingDate,  translate, meta: { touched, error, warning, asyncValidating } }) => {
  const options = []
  const NextBilling = moment(NextBillingDate).format("YYYY-MM-DD");
  const displayNextBilling = moment(NextBillingDate).format("DD/MM/YYYY");
   for (var i = 1; i < 12; i++) {
    const time = moment(NextBillingDate).add(i, 'M').format("YYYY-MM-DD")
    const displayTime = moment(NextBillingDate).add(i, 'M').format("DD/MM/YYYY");
    options.push(<option key={time} value={time}>{displayTime}</option>)
  }
  return(
    <div>
    <select {...input} className="form-control" size="size">
      <option value={NextBilling} hidden="hidden">{`(${translate("next-billing-date")}) ${displayNextBilling}`}</option>
      <option value={NextBilling}>{`(${translate("next-billing-date")}) ${displayNextBilling}`}</option>
      {options}
    </select>
    </div>
  )
}
export default NextBillingDateSelect;



// WEBPACK FOOTER //
// ./src/components/Freeze/NextBillingDateSelect.js